<script setup lang="ts">
import { onMounted } from 'vue';
import { useStayStore } from '../stores/stayStore';
import { useTreatmentStore } from '../stores/treatmentStore';
import TopBar from '../components/TopBar.vue';
import TreatmentList from '../components/treatments/TreatmentList.vue';
import LoginForm from '../components/auth/LoginForm.vue';
import type { BookingFormData } from '../types/treatment';

const stayStore = useStayStore();
const treatmentStore = useTreatmentStore();

onMounted(async () => {
  if (stayStore.token) {
    await treatmentStore.loadMassages();
  }
});

async function handleBooking(data: BookingFormData) {
  await treatmentStore.bookMassage(data);
}

async function handleLogin() {
  if (await stayStore.authenticate(stayStore.bookingNumber, stayStore.lastName)) {
    await treatmentStore.loadMassages();
  }
}
</script>

<template>
  <div>
    <TopBar />
    <div class="massage-container">
      <template v-if="!stayStore.token">
        <LoginForm @submit="handleLogin" />
      </template>
      <template v-else>
        <TreatmentList
          type="massage"
          :treatments="treatmentStore.massages"
          @book="handleBooking"
        />
      </template>
    </div>
  </div>
</template>

<style scoped>
.massage-container {
  margin-top: 48px;
  margin-bottom: 96px;
}
</style>